import './Head.css';

function Head() {
  return (
    <div className="head">
      <div className="title">
        <span>An Emoji</span> Search App
      </div>
      <div className="title-mobile">
        <span>An Emoji</span>
        <br /> Search App
      </div>
      <div className="subtitle">Search for an emoji and copy it by clicking on it</div>
    </div>
  );
}

export default Head;
